export default "__VITE_ASSET__Drtl88xk__ 640w, __VITE_ASSET__DrDe0pUa__ 960w, __VITE_ASSET__fkk_bevs__ 1280w, __VITE_ASSET__01P_L36B__ 1920w";